'use strict';

/*global app*/
/*global services*/

function ProductInfo() {
  this.$container = null;
  this.outputService = null;
  this.inputService = null;

  this.params = null;

  this.init();
}

ProductInfo.prototype = $.extend({}, {
  constructor: 'ProductInfo',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.$container.on('click', '.product-info__load-free-sectors', function () {
      _this.loadProductInfo(_this.params, $(this).data('page'));

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  loadProductInfo: function loadProductInfo(params, page) {
    var _this = this;

    var data = {
      stockId: params.StockId,
      abbr: params.ArticleAbbr,
      areaId: params.AreaId,
      page: page ? page : 0,
    };

    var modal = services.get('modal');
    modal.block();
    $.get(app.path('product_get', data), function (res) {
      modal.unBlock();

      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);
      } else {
        app.viewErrorMessage();
      }
    });

    return _this;
  },

  viewProductInfo: function viewProductInfo(params, page) {
    var _this = this;

    _this.params = params;

    var modal = services.get('modal');
    modal.open({
      title: app.t('item_form.product_info'),
      height: 'auto',
      width: 'md'
    });

    _this.loadProductInfo(params, page);

    return _this;
  },

  searchProductInfo: function searchProductInfo(value) {
    var _this = this;

    var modal = services.get('modal');
    modal.open({
      title: app.t('item_form.product_info'),
      height: 'auto',
      width: 'md'
    });

    modal.block();
    $.get(app.path('product_search_quick', { searchValue: value }), function (res) {
      modal.unBlock();

      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);
      } else {
        app.viewErrorMessage();
      }
    });

    return _this;
  },

  find: function find(value, callback) {
    var _this = this;

    $.get(app.path('product_find', { searchValue: value }), function (res) {
      callback(res.msg === 'SUCCESS', res.data);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('body');
    _this.outputService = services.get('output-service');
    _this.inputService = services.get('input-service');

    _this.registerCallbacks();

    return _this;
  }
});
